export default "__VITE_ASSET__BI_RR$82__"